import {connect} from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import {InstanceAPIs, Instances} from '../../../../constants';
import {IStateType} from '../../../../store/models/root.interface';
import {closeSideBar, getParams} from '../../../../store/sidebar';
import { removeObjects, updateObjects} from '../../../../store/Objects';

import AddUserGroupModal, {MapDispatchToPropsType, MapStateToPropsType} from '../organisms/AddSipAclModal';

const mapStateToProps = (state: IStateType) => {
    const params = getParams(state);
    return {
        params,
    };
};

const mapDispatchToProps = {
    closeModal: () => closeSideBar([]),
    addSipAcl: (reqData: any, cb?: (res: any, success: boolean)=> void) =>  updateObjects(Instances.SipACL, "POST", reqData, undefined, undefined, undefined, undefined, undefined, cb, "", InstanceAPIs[Instances.SipACL].POST),
    removeSipIpAddressInstance: () =>  removeObjects(Instances.SipIpAddresses),
    removeAclInstance: () =>  removeObjects(Instances.SipACL),
    addSipIpAddresses: (reqData: any,filters:any, dynamicUrlData:string, cb?: (res: any, success: boolean) => void) =>  updateObjects(Instances.SipIpAddresses, "POST", reqData, filters, undefined, undefined, undefined, undefined, cb, dynamicUrlData, InstanceAPIs[Instances.SipIpAddresses].POST),
};

export default connect<MapStateToPropsType, MapDispatchToPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(AddUserGroupModal));
